import React from 'react';
import PropTypes from 'prop-types';

import ModifyButton from './ModifyButton';

const HeaderBlock = ({ title, mode, id, toggleMode, strings, active }) => (
  <div className="header">
    <div className="title">{title}</div>
    {active ? (
      <ModifyButton
        mode={mode}
        name="personal-infos"
        id={id}
        toggleMode={toggleMode}
        strings={strings}
      />
    ) : (
      undefined
    )}
  </div>
);
HeaderBlock.propTypes = {
  title: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['view', 'edit']).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  toggleMode: PropTypes.func.isRequired,
  strings: PropTypes.objectOf(PropTypes.string).isRequired,
  active: PropTypes.bool
};

HeaderBlock.defaultProps = {
  active: true
};

export default HeaderBlock;
